
import { Options, prop, Vue } from "vue-class-component";
import SelectGroupV2 from "@/app/ui/components/select-group-v2/index.vue";
import { countries } from "@/app/infrastructures/misc/BulkData";
import { CustomerBookingV3 } from "@/domain/entities/CreateBookingV3";
import { formatPhoneCustomer } from "../../views/shipment/booking/booking-utils";
import { AccountController } from "../../controllers/AccountController";

class Props {
  options = prop<any[]>({
    default: [],
    type: Array
  });
  customerName = prop<string>({
    default: "",
    type: String
  });
  error = prop<any>({
    default: {},
    type: Object
  });
  disabled = prop<boolean>({
    default: false,
    type: Boolean
  });
  disabledOption = prop<boolean>({
    default: false,
    type: Boolean
  });
  column = prop<string>({
    default: "",
    type: String
  });
  loading = prop<boolean>({
    default: false,
    type: Boolean
  });
  keyName = prop<string>({
    default: "name",
    type: String
  });
  errorCaption = prop<string>({
    default: "",
    type: String
  });
  placeholder = prop<string>({
    default: "",
    type: String
  });
  isReverseJourney = prop<boolean>({
    default: false,
    type: Boolean
  });
  useInfiniteScroll = prop<boolean>({
    default: false,
    type: Boolean
  });
  editable = prop<boolean>({
    default: true,
    type: Boolean
  });
}

@Options({
  emits: [
    "focus",
    "setErrorCharMinimal",
    "changePhoneNumber",
    "editOption",
    "select",
    "change",
    "update:customerName",
    "scrolled"
  ],
  components: {
    SelectGroupV2
  },
  watch: {
    selectedCustomer: function() {
      this.$emit("select", formatPhoneCustomer(this.selectedCustomer));
    }
  }
})
export default class SelectCustomerV2 extends Vue.with(Props) {
  countryFiltered = countries;
  selectedCustomer = new CustomerBookingV3();

  formatName(value: string) {
    if (value.length > 100) return value.slice(0, 100);

    return value;
  }

  get customerNameModel() {
    return this.customerName;
  }

  set customerNameModel(value) {
    this.$emit("update:customerName", value);
  }

  highlightSearch(text: string): string {
    if (!this.customerName) return text;

    return text.replace(
      this.customerName,
      `<strong>${this.customerName}</strong>`
    );
  }

  onChange(value: string) {
    this.$emit("update:customerName", value);
  }
  onFocus() {
    this.$emit("focus");
  }
  onBlur() {
    this.$emit("blur");
  }
  get isEditItem() {
    return !AccountController.accountData.isInternalAccount && this.editable;
  }
  onEditOption(item: CustomerBookingV3) {
    window.open(`/management-customer/edit?id=${item.customerId}`, "_blank");
  }

  onScroll() {
    this.$emit("scrolled");
  }
}
